(function () {
  "use strict";

  if (typeof window.initAwolCountdowns === "function") {
    window.initAwolCountdowns();
    return;
  }

  const getBeijingNow = () => {
    const beijingTime = new Date().toLocaleString("zh-CN", { timeZone: "Asia/Shanghai" });
    return new Date(beijingTime).getTime();
  };

  const pad = (value) => (value < 10 ? "0" + value : String(value));

  class AwolCountdown {
    constructor(container) {
      this.container = container;
      const endTimeStr = this.container.dataset.endTime;

      if (!endTimeStr) return;

      this.endTime = new Date(endTimeStr).getTime();

      if (Number.isNaN(this.endTime)) return;

      this.timer = null;
      this.daysEle = this.container.querySelector(".index-days");
      this.hoursEle = this.container.querySelector(".index-hours");
      this.minutesEle = this.container.querySelector(".index-minutes");
      this.secondsEle = this.container.querySelector(".index-seconds");

      if (!this.daysEle || !this.hoursEle || !this.minutesEle || !this.secondsEle) return;

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    tick() {
      const diff = this.endTime - getBeijingNow();

      if (diff <= 0) {
        this.stop();
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      this.daysEle.textContent = pad(days);
      this.hoursEle.textContent = pad(hours);
      this.minutesEle.textContent = pad(minutes);
      this.secondsEle.textContent = pad(seconds);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  const initAwolCountdowns = () => {
    document.querySelectorAll(".index-countdown[data-end-time]:not([data-countdown-init])").forEach((container) => {
      container.dataset.countdownInit = "true";
      new AwolCountdown(container);
    });
  };

  window.AwolCountdown = AwolCountdown;
  window.initAwolCountdowns = initAwolCountdowns;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAwolCountdowns);
  } else {
    initAwolCountdowns();
  }
})();
